import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --primary-gradient: linear-gradient(135deg, #d395ff, #ff7fd9);
    --primary-color: #d395ff;
    --secondary-color: #ff7fd9;
    --dark-bg: #0a0a0a;
    --light-bg: #ffffff;
    --text-dark: #0a0a0a;
    --text-light: #ffffff;
    --text-gray: #666666;
    --text-light-gray: #999999;
    --border-light: rgba(0, 0, 0, 0.05);
    --border-dark: rgba(255, 255, 255, 0.1);
    --shadow-sm: 0 5px 20px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 10px 30px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 20px 40px rgba(0, 0, 0, 0.15);
    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  body {
    font-family: 'Inter', sans-serif;
    color: var(--text-dark);
    line-height: 1.6;
    overflow-x: hidden;
  }

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 5%;
  }

  .section-padding {
    padding: 6rem 0;
  }

  @media (max-width: 768px) {
    .section-padding {
      padding: 4rem 0;
    }
  }
`;

export default GlobalStyles;